import React from "react";
import image from '../../../images/situation/maten/kozijn/K.jpg'
import PropTypes from "prop-types";

MaatK.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onEnter: PropTypes.func.isRequired
}
export default function MaatK(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Hier kunt u de breedte van de kozijnstijl invullen.<br/>
        </div>
        <input
            className="phoneInput"
            onChange={props.onChange}
            value={props.value}
            type="number"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            placeholder="Vul hier de maat in..."
        />
        <img className="explainImagePhone" src={image} alt=""/>
    </div>;
}